//Components
import If from "@mobi/components/If"

//Style
import "./index.scss"

const Loader = ({ logo, logoAlt, hideLogo = false }) => {
  return (
    <div
      className="loader"
      aria-busy="true"
      aria-live="assertive"
      role="alert"
      aria-label="Carregando..."
    >
      <div className="loader__content">
        {}
        <If
          condition={!hideLogo}
          renderIf={
            <div className="loader__logo">
              <img src={logo} alt={logoAlt} />
            </div>
          }
        />
        <div className="loader__spinner" />
      </div>
    </div>
  )
}

export default Loader
